// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"28ed01f9","171":"37bc0bba","213":"9a416da2","239":"4c2aee6a","244":"9fcde498","369":"4f70e3ce","438":"bd63aa76","453":"75edf7e6","455":"a27ba876","513":"472aa033","639":"b425e004","839":"83cf19d1","913":"b9d4f5a3"}[chunkId] + ".chunk.js";
};